import { Address } from './address.model';

export interface LegalPersonsInfoNoneVoting {
  values: LegalPersonNoneVoting[];
}

export class LegalPersonNoneVoting {
  legalForm: ILegalForm;
  headOfficeAddress: Address;
  trusteeNumber: number;
  odqMembers: OdqMembers[];
  spouseRelatives: ISpouseRelative[];

  static get empty(): LegalPersonNoneVoting {
    return {
      legalForm: {
        effectiveDate: null,
        endingDate: null,
        legalEntityName: '',
        neq: '',
        nonVotingShares: null,
        type: LegalForm.None,
      },
      headOfficeAddress: {
        line1: '',
        line2: '',
        city: '',
        provinceCode: '',
        postalCode: '',
        countryCode: '',
      },
      odqMembers: [],
      spouseRelatives: [],
      trusteeNumber: null,
    };
  }
}

// LEGAL FORM
export interface ILegalForm {
  type: LegalForm;
  nonVotingShares: number;
  effectiveDate: Date;
  endingDate: Date;
  legalEntityName: string;
  neq: string;
}

export enum LegalForm {
  None, LegalPerson, Trust, OtherCompany,
}

// ODQ MEMBERS
export class OdqMembers {
  firstName: string;
  lastName: string;
  permitNumber: string;
  memberTypes?: OdqMemberType[] = [];
}

export enum OdqMemberType {
  Shareholder = 1, Trustee = 2, Director = 3, Officer = 4, ManagementDuties = 5,
}

// SPOUSE/RELATIVE
export interface ISpouseRelative {
  firstName: string;
  lastName: string;
  relationType: string;
  member: OdqMembers;
}
